import React from 'react'
import { Button, Card, Modal, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap'
import InputField from '../../jsx/components/fields/inputField'
import SearchAddressInput from '../../jsx/components/fields/searchAddressInput'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import { getWorkInformation } from '../../service/api/professional/getWorkInformation';
import { saveWorkInformation } from '../../service/api/professional/saveWorkInformation';
import { getCat } from '../../service/api/object/getCat';
import { getProductType } from '../../service/api/object/getProdType';
import { saveExpertise } from '../../service/api/professional/saveExpertise';
import delelteExpertise from '../../service/api/professional/deleteExpertiseById';
import Select from "react-select";
import { searchAddress } from '../../service/api/user/searchAddress';
import { addressByPlaceId } from '../../service/api/user/addressByPlaceID';

import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';

import { emailValidation, firstNameValidation, numberValidation, phoneValidation } from '../../functions/validations'


import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ActionButton from '../../jsx/components/button/ActionButton'
import SelectInputCategories from '../../jsx/components/fields/selectInputCategories'
import SelectInputCompetency from '../../jsx/components/fields/selectInputCompetency'
import SelectInputCertification from '../../jsx/components/fields/selectInputCertification'
import PhonenumberTagCompany from '../../jsx/components/fields/phonenumberTagCompany'
import ResponceForAPI from '../../component/backDrop/responcesForAPI'
import { phoneOnChange } from '../../validations/validation'
import { btnSaveExpertise, btnSaveExpertiseLoading, btnSaveWork, btnSaveWorkLoading, btnWorkInfo } from '../../dataBaseFile/alert'
import { lblAddress, lblCompanyAddress, lblCompanyName, lblEmail, lblExpertise, lblPhoneNumber, txtAddExpertise, txtCertificate, txtCertification, txtCertified, txtEditExpertise, txtExpInExpertise, txtExpertiseCompetency, txtExpertiseDeleteConfirmation, txtExpertiseDetails, txtExpertiseName, txtMobileNumber, txtPleaseAddExpertise, txtSearchCompanyAddress, txtWorkExperience } from '../../dataBaseFile/label'
import { validTotalWorkExp } from '../../dataBaseFile/error'
import TextArea from '../../jsx/components/fields/textArea'
import updateServiceRequestoptionApi from '../../service/api/user/updateServiceRequestoption'
import { userById } from '../../service/api/user/userById'
import { setExpertiseTriggerRedux, setUserDetails } from '../../feature/userData/userData'

const WorkInfoCopy = ({ adminTrigger = false }) => {
    const { serviceRequestOptions, serviceRequestFlagPro, expertiseTriggerRedux } = useSelector((state) => state.user);
    const dispatch = useDispatch()


    const [expertiseCompetencyArr, setExpertiseCompetencyArr] = useState([]);

    // Work info states 
    const [companyName, setCompanyName] = useState('');
    const [experience, setExperience] = useState();

    const [companyMail, setCompanyMail] = useState('');
    const [companyPhoneCode, setcompanyPhoneCode] = useState(0);
    const [companyPhone, setcompanyPhone] = useState("");
    const [companyAddress, setCompanyAddress] = useState('');

    const [expertiseName, setExpertiseName] = useState('');
    const [expertiseCompetencey, setExpertiseCompetencey] = useState('');
    const [expertiseExp, setExpertiseExp] = useState(0);
    const [expertiseCertificate, setExpertiseCertificate] = useState('');

    const [isExperienceError, setIsExperienceError] = useState(false);
    const [errorCompanyMail, setErrorCompanyMail] = useState(false);
    const [isCompanyPhoneError, setIsCompanyPhoneError] = useState(false);


    const [isSuccessButtonWork, setIsSuccessButtonWork] = useState(false);
    const [isErrorButtonWork, setIsErrorButtonWork] = useState(false);
    const [staticButton, setStaticButton] = useState(true);


    const [countryCodeCompany, setCountryCodeCompany] = useState("+1")

    const [addressArrCompany, setAddressArrCompany] = useState([])
    const [searchTextCompany, setSearchTextCompany] = useState('')
    const [placeIdValCompany, setPlaceIdCompany] = useState('')

    const [addressLine1Company, setAddressLine1Company] = useState("");
    const [addressLine2Company, setAddressLine2Company] = useState("");
    const [cityNameCompany, setCityNameCompany] = useState('')
    const [stateNameCompany, setStateNameCompany] = useState('')
    const [countryNameCompany, setCountryNameCompany] = useState('')
    const [zipCodeCompany, setZipCodeCompany] = useState(0)

    const [latValCompany, setLatValCompany] = useState(0)
    const [longValCompany, setLongValCompany] = useState(0)

    const [proExpertiseArr, setProExpertiseArr] = useState([]);

    const [responceMsg, setResponceMsg] = useState("");
    const [updateWorkLoading, setUpdateWorkLoading] = useState(false);
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);

    const [saveExpertiseName, setSaveExpertiseName] = useState('')
    const [saveExpertiseProductName, setSaveExpertiseProductName] = useState('')
    const [saveExpertiseProductNameErr, setSaveExpertiseProductNameErr] = useState(false)
    const [saveExpertiseCompetency, setSaveExpertiseCompetency] = useState('');
    const [saveExpertiseExp, setSaveExpertiseExp] = useState('');
    const [saveExpertiseCertificate, setSaveExpertiseCertificate] = useState(0);

    const [isExpertiesNameError, setIsExpertiesNameError] = useState(false);
    const [isExpertiesCompetencyError, setIsExpertiesCompetencyError] = useState(false);
    const [isExpertiesCertificationError, setIsExpertiesCertificationError] = useState(false);

    const [isExpertiesExpError, setIsExpertiesExpError] = useState(false);

    const [isEditedExpertiseId, setIsEditedExpertiseId] = useState("");

    const [saveExpertiseLoading, setSaveExpertiseLoading] = useState(false);

    const [expertiseNameDia, setExpertiseNameDia] = useState('');
    const [productDia, setProductDia] = useState('');
    const [expertiseCompetencyDia, setExpertiseCompetencyDia] = useState('');
    const [expertiseExpDia, setExpertiseExpDia] = useState('');
    const [expertiseCertifiedDia, setExpertiseCertifiedDia] = useState('');
    const [expertiseID, setExpertiseID] = useState('');

    const [apiResponce, setApiResponse] = useState(false);

    const [firstAPIRes, setFirstAPIRes] = useState(false)

    const [expertiseObject, setExpertiseObject] = useState({});

    const [bioText, setBioText] = useState('');

    const certificationArr = [
        { key: 1, value: 'Yes' },
        { key: 0, value: 'No' },
    ]

    const expertiseArr = [
        { expertiseName: 'Appliances' },
        { expertiseName: 'Plumbing' },
        { expertiseName: 'HAVC' },
        { expertiseName: 'Electrical' },
        // { expertiseName: 'Landscaping' },
    ]

    // Tooltips here
    const tooltipAdd = (
        <Tooltip id="tooltip" >
            <strong >Add Expertise</strong>
        </Tooltip>
    );
    const tooltipEdit = (
        <Tooltip id="tooltip" >
            <strong >Edit Expertise</strong>
        </Tooltip>
    );
    const tooltipDelete = (
        <Tooltip id="tooltip" >
            <strong >Delete Expertise</strong>
        </Tooltip>
    );


    // Modal triggers for the expertise
    // const [expertiseTrigger, setExpertiseTrigger] = useState(false);

    const [expertiseTrigger, setExpertiseTrigger] = useState(expertiseTriggerRedux);
    const [expertiseModalTitle, setExpertiseModalTitle] = useState(1);
    const [getCatApiFlag, setGetCatApiFlag] = useState(false);

    useEffect(() => {
        if (expertiseTrigger) {
            dispatch(setExpertiseTriggerRedux(true));
        } else if (!expertiseTrigger) {
            dispatch(setExpertiseTriggerRedux(false));
        }
    }, [expertiseTrigger])

    useEffect(() => {
        if (getCatApiFlag || expertiseTriggerRedux) {
            getCategoriesData();
        }
    }, [getCatApiFlag])
    function handleOpenExpertiseTrigger(e, actionFlag, id = null,) {
        e.stopPropagation();
        setExpertiseModalTitle(actionFlag);
        setExpertiseTrigger(true);

        if (actionFlag == 1) {
            setGetCatApiFlag(true)
        }

        // For deleting expertise dia
        if (id !== null) {
            setExpertiseID(id);
            // setOpenExpDialog(true);
            let dialogObject = proExpertiseArr?.find((element, index) => {
                return element.expertise_id_ids === id
            })
            // console.log(dialogObject)
            setExpertiseNameDia(dialogObject.expertise_name_chr)
            setProductDia(dialogObject?.product_type_expertise_record[0]?.expertise_name_chr)
            setExpertiseCompetencyDia(dialogObject?.expertise_competency_name)
            setExpertiseExpDia(dialogObject?.work_experience_int)
            let certificate_ysn = dialogObject?.is_certified_ysn == 1 ? "Yes" : "No"
            setExpertiseCertifiedDia(certificate_ysn)
        }
        setActivePopover(null)
    }

    function handleCloseExpertiseTrigger() {
        setExpertiseTrigger(false);
        setSaveExpertiseProductNameErr(false);
        // clearEditExpertise();
        clearExpertiseState();
        setIsEditedExpertiseId("")

    }


    // Set the initial work info
    const setInitialWorkInfo = (res) => {
        setCompanyName(res?.data?.data?.professional_work_info?.campany_name_chr)
        setExperience(res?.data?.data?.professional_work_info?.total_work_experience_int)
        setCompanyMail(res?.data?.data?.professional_work_info?.work_email_chr)
        setcompanyPhone(res?.data?.data?.professional_work_info?.work_phone_number_int);

        // setcompanyPhoneLength(res.data.data.professional_work_info.work_phone_number_int.length);

        setcompanyPhoneCode(res?.data?.data?.professional_work_info?.work_phone_code_id_lng);
        setCompanyAddress(res?.data?.data?.professional_work_info?.work_complete_address_chr);
        setExpertiseName(res?.data?.data?.professional_expertise_info?.expertise_name_chr);

        setStateNameCompany(res?.data?.data?.professional_address?.state_name_chr)

        setAddressLine1Company(res?.data?.data?.professional_address?.address_line_1_chr)
        setAddressLine2Company(res?.data?.data?.professional_address?.address_line_2_chr)

        setCityNameCompany(res?.data?.data?.professional_address?.city_name_chr)
        setZipCodeCompany(res?.data?.data?.professional_address?.zip_code_int)
        setCountryNameCompany(res?.data?.data?.professional_address?.country_name_chr)
        setCompanyAddress(res?.data?.data?.professional_work_info?.work_complete_address_chr)
        setLongValCompany(res?.data?.data?.professional_address?.longitute_float)
        setLatValCompany(res?.data?.data?.professional_address?.latitude_float)
        setPlaceIdCompany(res?.data?.data?.professional_address?.place_id_chr)

        res?.data?.data?.professional_expertise_info && setProExpertiseArr(res?.data?.data?.professional_expertise_info)

        // console.log(res, "All work data here")
        setExpertiseCompetencyArr(res?.data?.expertise_competency_list)

        // console.log(res?.data?.expertise_competency_list, "expertiseCompetencyArr init")

        var expertiseName;
        res?.data?.data?.professional_expertise_info?.map((element, index) => {
            if (index === 0) {
                expertiseName = element?.expertise_name_chr
            }
        })
        setExpertiseName(expertiseName)

        var expertiseLevel;
        res?.data?.data?.professional_expertise_info?.map((element, index) => {
            if (index === 0) {
                expertiseLevel = element?.expertise_competency_int
            }
        })
        setExpertiseCompetencey(expertiseLevel)


        var expertiseWorkExperience;
        res?.data?.data?.professional_expertise_info?.map((element, index) => {
            if (index === 0) {
                expertiseWorkExperience = element?.work_experience_int
            }
        })
        setExpertiseExp(expertiseWorkExperience)

        var expertiseCertified;
        res?.data?.data?.professional_expertise_info?.map((element, index) => {
            if (index === 0) {
                expertiseCertified = element?.is_certified_ysn
            }
        })
        setExpertiseCertificate(expertiseCertified)
    }

    const getWorkInfoFn = () => {
        let details = {
            user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
        }

        setFirstAPIRes(true)

        dispatch(
            getWorkInformation(details, (res) => {
                // console.log(res, "user work Data comes here")

                setExpertiseCompetencyArr(res?.data?.expertise_competency_list)
                setInitialWorkInfo(res)
                setFirstAPIRes(false)
            }),
            (res) => {
                setFirstAPIRes(false)
            }
        )
    }





    useEffect(() => {
        getWorkInfoFn();
    }, [])



    // console.log(expertiseCompetencyArr, "expertiseCompetencyArr")

    // Work Info functions
    const handleCompanyName = (e) => {
        setCompanyName(e.target.value);
    }

    const handleCompanyMail = (e) => {
        setErrorCompanyMail(false);
        setCompanyMail(e.target.value);
    }

    const handleCountryCodeCompany = (e) => {
        setcompanyPhoneCode(e.target.value)
    }

    const handleCompanyPhone = (e) => {
        setIsCompanyPhoneError(false);
        phoneOnChange(e.target.value) && setcompanyPhone(e.target.value);
    }
    const handleCompanyPhoneBlurCheck = () => {
        if (companyPhone.toString().length == 0) {
            setIsCompanyPhoneError(false);
        }
        else if (companyPhone.toString().length == 10) {
            setIsCompanyPhoneError(false);
        }
        else if (!phoneValidation(companyPhone)) {
            setIsCompanyPhoneError(true);
        }
    }

    function handleEmailCompanyBlurCheck() {
        if (companyMail.length == 0) {
            setErrorCompanyMail(false);
        }
        else if (!emailValidation(companyMail)) {
            setErrorCompanyMail(true);
            if (!companyMail.includes('@') || !companyMail.includes('.com')) {
                setErrorCompanyMail(true);
                return;
            }
        }
    }
    const handleCompanyAdd = (e) => {
        setCompanyAddress(e.target.value);
    }

    // Save work information
    const saveWorkInfo = (e) => {
        e.preventDefault();
        // setSaveWorkLoading(true);
        setUpdateWorkLoading(true);
        setApiResponse(true);

        if (companyMail !== "" && companyMail !== null) {
            if (!companyMail.includes('@') || !companyMail.includes('.com')) {
                setErrorCompanyMail(true);
                // setSaveWorkLoading(false);
                setUpdateWorkLoading(false);
                setApiResponse(false);
                return;
            }
        }
        if (companyPhone !== "" && companyPhone !== null) {
            // if(!phoneValidation(companyPhone)){
            //   setIsCompanyPhoneError(true);
            //   return;
            // }
            if (companyPhone.toString().length !== 10 || isNaN(companyPhone)) {
                setIsCompanyPhoneError(true);
                // setSaveWorkLoading(false);
                setUpdateWorkLoading(false);
                setApiResponse(false);
                return;
            }
        }

        const details = {
            user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
            company_name_chr: companyName || "",
            work_phone_code_id_int: +companyPhoneCode || 0,
            work_phone_number_int: +companyPhone || 0,
            work_email_chr: companyMail || "",
            total_work_experience_int: +experience || 0,
            place_id_chr: placeIdValCompany || "",
            address_line_1_chr: addressLine1Company || "",
            address_line_2_chr: addressLine2Company || "",
            city_name_chr: cityNameCompany || "",
            state_name_chr: stateNameCompany || "",
            country_name_chr: countryNameCompany || "",
            zip_code_int: +zipCodeCompany || 0,
            longitute_float: parseFloat(longValCompany) || 0,
            latitude_float: parseFloat(latValCompany) || 0,
            work_complete_address_chr: companyAddress ? companyAddress : "",
            experties_info: [
                // {
                //   expertise_id_ids: 2,
                //   expertise_name_chr: 'expertiseName',
                //   expertise_competency_int: '+expertiseCompetencey',
                //   work_experience_int: '+expertiseExp',
                //   is_certified_ysn: 'expertiseCertificate'
                // },
            ]
        }

        // console.log(details, "Details here");

        // if(experience != ""){
        //   if(isNaN(experience) || experience==""){
        //     setIsExperienceError(true);
        //     return;
        //   }
        // }





        // if(emailValidation(companyMail) || numberValidation(experience)) {
        dispatch(
            saveWorkInformation(
                details,
                (res) => {
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    let details = {
                        user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                    }
                    // Here we do the get data of work informations
                    dispatch(
                        getWorkInformation(details, (res) => {

                            setInitialWorkInfo(res)
                        }),
                    )

                    setUpdateWorkLoading(false);
                    setApiResponse(false);

                    // setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
                (res) => {
                    setResponceMsg(res.data.message);
                    setToasterType("error");
                    setUpdateWorkLoading(false);
                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
            ),
        )
        // }
    }

    // Get the categories
    const [pageSizeCat, setPageSizeCat] = useState(25);
    const [pageCat, setPageCat] = useState(1);
    const [catOrder, setCatOrder] = useState("ASC")
    const [catArr, setCatArr] = useState([]);
    const [catId, setCatId] = useState();
    const [prodTypeArr, setProdTypeArr] = useState([]);

    // useEffect(() => {
    //     var forCatData = {
    //         page_index: pageCat,
    //         page_size: pageSizeCat,
    //         sorting_order: catOrder
    //     };

    //     dispatch(
    //         getCat(forCatData, (res) => {
    //             setCatArr(res.data.data)
    //         }))

    // }, [pageCat, pageSizeCat, catOrder])

    const getCategoriesData = () => {
        var forCatData = {
            page_index: pageCat,
            page_size: pageSizeCat,
            sorting_order: catOrder
        };

        dispatch(
            getCat(forCatData, (res) => {
                setCatArr(res.data.data)
            }))
    }

    // Getting the product type
    function handleSetCatId(eleID) {
        if (eleID === -2) {
            setCatId(eleID);

        } else {

            setCatId(eleID);
            var data = {
                category_id_ids: eleID,
            };

            dispatch(
                getProductType(
                    data,
                    (res) => { setProdTypeArr(res.data.data) },
                    (err) => { }
                )
            );
        }
    }

    // Professionals Expertise Functions 
    const [forGettingProductType, setforGettingProductType] = useState();
    const saveExpertiseNameFn = (e) => {

        setSaveExpertiseName(e.target.value);
        // console.log(e.target.value);
        setIsExpertiesNameError(false);

        // This code is for getting the product type based on the expertise name
        // catArr.map((element) => {
        //     if (element.category_id_ids === e.target.value) {
        //         // setSaveExpertiseName(element.category_name_chr);
        //         // console.log(element.category_name_chr)
        //         setforGettingProductType(element.category_id_ids);
        //     }
        // })
        // handleSetCatId(2)
    }

    const saveExpertiseCompetencyFn = (e) => {
        setSaveExpertiseCompetency(e.target.value);
        setIsExpertiesCompetencyError(false);
    }
    const saveExpertiseExpFn = (e) => {
        setIsExpertiesExpError(false)
        setSaveExpertiseExp(e.target.value.replace(/\D/g, ''));
    }
    const handleSaveExpertiseExpBlurCheck = () => {
        if (isNaN(saveExpertiseExp) || saveExpertiseExp === '' || (saveExpertiseExp > 99)) {
            setIsExpertiesExpError(true);
        }
    }

    const saveExpertiseCertificateFn = (e) => {
        setSaveExpertiseCertificate(e.target.value);
        setIsExpertiesCertificationError(false);
    }


    function clearExpertiseState() {
        setSaveExpertiseName('')
        setSaveExpertiseCompetency('')
        setSaveExpertiseExp('')
        setBioText('')
        setSaveExpertiseCertificate(0)
        setSaveExpertiseProductName('')
        setIsExpertiesExpError(false);
        setIsEditedExpertiseId("");
        setIsExpertiesNameError(false);
        setIsExpertiesCompetencyError(false);
        setIsExpertiesCertificationError(false);
    }

    // Save professional expertise
    function saveProfessionalExperties(e) {
        e.preventDefault();
        setSaveExpertiseLoading(true);
        setApiResponse(true);
        if (isNaN(saveExpertiseExp) || saveExpertiseExp === '' || (saveExpertiseExp > 99)) {
            setIsExpertiesExpError(true);
            setSaveExpertiseLoading(false);
            setApiResponse(false);
        }
        if (saveExpertiseName == "") {
            setApiResponse(false);
            setSaveExpertiseLoading(false);
            setIsExpertiesNameError(true);
        }
        if (saveExpertiseCompetency == "") {
            setApiResponse(false);
            setSaveExpertiseLoading(false);
            setIsExpertiesCompetencyError(true);
        }

        // console.log(saveExpertiseCertificate, "saveExpertiseCertificate")
        // Changes with condition done

        if (isNaN(saveExpertiseExp) || (saveExpertiseExp === '') || (saveExpertiseExp > 99)
            || (saveExpertiseName == "") || (saveExpertiseCompetency == "")) {
            setApiResponse(false);
            setSaveExpertiseLoading(false);
            // setIsExpertiesCertificationError(true);
            return;
        }

        if (!isExpertiesExpError && !isExpertiesNameError && !isExpertiesCompetencyError) {

            const details = {
                user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                expertise_id_ids: isEditedExpertiseId != null ? isEditedExpertiseId : "",
                expertise_name_chr: saveExpertiseName,
                expertise_competency_int: parseInt(saveExpertiseCompetency),
                work_experience_int: parseInt(saveExpertiseExp),
                is_certified_ysn: saveExpertiseCertificate ? 1 : 0,
                bio_chr: bioText,
                product_type_experties_info: [],
            }

            // details.product_type_experties_info.push(newObject)

            // Checking for already presented product name 
            if (saveExpertiseProductNameErr) {
                return;
            }

            if (numberValidation(saveExpertiseExp)) {
                dispatch(
                    saveExpertise(
                        details,
                        (res) => {
                            setResponceMsg(res.data.message);
                            // console.log(res.data.message);
                            setToasterType("success")
                            let details = {
                                user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                            }
                            // Here we do the get data of work informations
                            dispatch(
                                getWorkInformation(details, (res) => {

                                    setInitialWorkInfo(res)
                                }),
                            )
                            clearExpertiseState();
                            handleCloseExpertiseTrigger();

                            setSaveExpertiseLoading(false);
                            setApiResponse(false);

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     // clearExpertiseState();
                            //     setHandleToaster(false);
                            // }, 11000);

                        },
                        (res) => {
                            setResponceMsg(res.data.message);
                            setToasterType("error")
                            // console.log(res.data.message);
                            // handleCloseExpertiseTrigger();

                            // clearExpertiseState();

                            setSaveExpertiseLoading(false);
                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        },
                    )
                )
            }
        }
    }

    // Delete the Professional Expertise 
    function delelteExpertiseWithProduct(expertiseID) {
        setSaveExpertiseLoading(true);
        // console.log("Delete Item !!!", id)
        let details = {
            expertise_id_ids: expertiseID,
        };
        dispatch(
            delelteExpertise(details, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("success")
                // console.log("Expertise Deleted Successfully!!!")
                // Here we do the get data of work informations
                let details = {
                    user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                }
                dispatch(
                    getWorkInformation(details, (res) => {

                        setInitialWorkInfo(res)
                    }),
                )
                handleCloseExpertiseTrigger();

                setSaveExpertiseLoading(false);

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (res) => {
                setResponceMsg(res.data.message);

                handleCloseExpertiseTrigger();
                setSaveExpertiseLoading(false);

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }
            )
        )
    }

    // Edit Professional Expertise
    function editExpertise(e, element) {
        // console.log(element, '-------------------');
        e.stopPropagation();

        setIsEditedExpertiseId(element.expertise_id_ids)

        // setEditExpertiseName(element?.expertise_name_chr)
        // setEditExpertiseCompentency(element?.expertise_competency_int)
        // setEditExpertiseExp(element?.work_experience_int)
        // setEditExpertiseCertificate(element?.is_certified_ysn)

        setSaveExpertiseName(element?.expertise_name_chr)
        setSaveExpertiseCompetency(element?.expertise_competency_int)
        setSaveExpertiseExp(element?.work_experience_int)
        setSaveExpertiseCertificate(element?.is_certified_ysn)
        setBioText(element?.bio_chr)

        // console.log("Expertise Name : ", saveExpertiseName);
        // console.log("Expertise Competency : ", saveExpertiseCompetency);
        // console.log("Work Experience : ", saveExpertiseExp);
        // console.log("Certified : ", saveExpertiseCertificate);

        // setToggleProExperties(2);

        handleOpenExpertiseTrigger(e, 2);
    }

    function hanldeChangeAddressCompany(e) {
        setSearchTextCompany(e.target.value)
    }
    useEffect(() => {
        const timeOutId = setTimeout(searchCallingCompany, 1000);
        return () => clearTimeout(timeOutId);
    }, [searchTextCompany]);

    function searchCallingCompany() {
        if (searchTextCompany.trim().length > 2) {

            let details = {
                address_chr: searchTextCompany.trim(),
            };
            dispatch(
                searchAddress(details, (res) => { setAddressArrCompany(res.data.data) })
            );
        }
    }

    const popover = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            editExpertise(e, expertiseObject);
                            // setActivePopover(null)
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>
                    <div
                        onClick={(e) => {
                            handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
                            // setActivePopover(null)
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const [showPopover, setShowPopover] = useState(false);
    const [activePopover, setActivePopover] = useState(null);


    const handleMenuClick = (element, index) => {
        setExpertiseObject(element)
        setActivePopover(activePopover === index ? null : index)
    }

    const handleBioText = (e) => {
        setBioText(e.target.value);
    }

    function handleGetUserById(e) {
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0,
        };

        dispatch(
            userById(
                details,
                (res) => {
                    setApiResponse(false);
                    dispatch(setUserDetails(res.data.data));
                    localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
                },
                (err) => { }
            )
        );
    }

    const [useChilllModalTrigger, setUseChilllModalTrigger] = useState(false);
    const [serviceReqOptionId, setServiceReqOptionId] = useState(serviceRequestFlagPro);
    const [serviceReqOptionErr, setServiceReqOptionErr] = useState(false);
    const [serviceReqOptionLoading, setServiceReqOptionLoading] = useState(false);

    const handleOpenUseChilllModal = () => {
        setUseChilllModalTrigger(true);
    }

    const handleCloseUseChilllModal = () => {
        setUseChilllModalTrigger(false);
    }

    const handleServiceRequestoption = (ele) => {
        setServiceReqOptionId(ele.option_id_ids);
        setServiceReqOptionErr(false);
    }

    const handleSubmitServiceReqOption = () => {
        if (serviceReqOptionId) {
            setServiceReqOptionLoading(true);
            let data = new FormData();
            data.append('user_id_ids', localStorage.getItem('user_id'));
            data.append('service_request_flag', serviceReqOptionId);

            dispatch(
                updateServiceRequestoptionApi(data,
                    (res) => {
                        setServiceReqOptionLoading(false);
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        handleCloseUseChilllModal();
                        // setHandleToaster(true);
                        handleGetUserById();

                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 5000);
                    },
                    (res) => {
                        setServiceReqOptionLoading(false);
                        setResponceMsg(res.data.message)
                        setToasterType("error")
                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
            )
        } else {
            setServiceReqOptionErr(true);
        }
    }


    return (
        <>
            <Card className='w-100' style={{ position: 'relative' }}>
                <div className='row mx-0  w-100 h-100'>
                    <div className=' col-12 p-4' style={{}}>
                        <div className='row border-3  mx-0 pb-2'>
                            <div className='col-9 fs-4 fw-bold px-0 text-black'>
                                <span>My expertise</span>
                            </div>
                            <div className='col-3 fs-4 fw-normal px-0 text-end'>
                                <span onClick={(e) => handleOpenExpertiseTrigger(e, 1)} className='cursor-pointer font-w500  overlay-action-btn px-2 rounded-1'>Add</span>
                            </div>
                        </div>

                        {/* <div className='row mx-0 my-2'>
                            <div className='col-12 px-0'>
                                <span onClick={(e) => handleOpenUseChilllModal(e)} className='cursor-pointer font-w500  overlay-action-btn px-2 rounded-1 fs-6'>Use Chilll to</span>
                            </div>
                        </div> */}

                        {proExpertiseArr?.length > 0 ?

                            <div className='row h-100 mx-0 '>
                                <div className='col-12 px-0' style={{}}>
                                    <div className='mt-2 mx-0 row'>
                                        {proExpertiseArr?.map((element, index) => {
                                            return (
                                                <div key={index} className='bg-white border rounded-3 col-12 mb-2 p-3 shadow-sm'>
                                                    <div className='row mx-0'>
                                                        <div className='col-12 px-0 d-flex'>

                                                            <div
                                                                className='align-items-center d-flex justify-content-center rounded-3 border text-black me-3'
                                                                style={{ width: '70px' }}
                                                            >
                                                                {element?.category_image_url_chr ?
                                                                    <img src={element?.category_image_url_chr} className='w-100 h-100' style={{ objectFit: 'contain' }} alt='' />
                                                                    :
                                                                    <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                                }
                                                            </div>

                                                            <div className='d-flex justify-content-between w-100'>
                                                                <div className=' px-0 text-black'>
                                                                    <div className='fs-6 fw-bold row mb-1'>
                                                                        <span>{`${element?.expertise_display_name_chr == "Home Check-Up" ? "Home Inspector" : element?.expertise_display_name_chr}`}</span>
                                                                    </div>
                                                                    <div className='row fs-7'>
                                                                        <span>{`${element?.work_experience_int} years experience`}</span>
                                                                    </div>
                                                                    <div className='font-w600 row fs-7 d-flex'>
                                                                        <div className='col-12'>
                                                                            <span>{`${element?.expertise_competency_name}, `}</span>
                                                                            <span>{`${element?.is_certified_ysn == 1 ? "Certified" : "Not certified"}`}</span>
                                                                            {element?.is_certified_ysn == 1 && <span><i className="bi bi-patch-check-fill ps-2 text-success"></i></span>}
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                <div className='px-0 text-black'>
                                                                    <div className='fs-5 fw-bold row mb-1'>

                                                                        <div className="tooltipCustom">
                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"More"}</span>
                                                                            <OverlayTrigger
                                                                                key={index}
                                                                                trigger="click"
                                                                                placement="bottom"
                                                                                // overlay={popover}
                                                                                overlay={popover(index)}
                                                                                rootClose={true}
                                                                                show={activePopover === index}
                                                                                onToggle={(show) => setActivePopover(show ? index : null)}
                                                                            >
                                                                                <span
                                                                                    className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                                    style={{ height: '30px', width: '30px' }}
                                                                                    onClick={() => handleMenuClick(element, index)}
                                                                                >
                                                                                    <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        }

                                    </div>

                                </div>
                            </div> :
                            <div className='row align-items-center h-100 justify-content-center mx-0 '>
                                <div className='col-12 px-0' style={{}}>
                                    <div className='row align-items-center justify-content-center mx-0'>
                                        <div className='col-12 rounded-circle bg-white' style={{ height: '5rem', width: '5rem' }}>

                                        </div>
                                    </div>

                                    <div className='align-items-center justify-content-center mx-0 pt-3 row'>
                                        <div className='col-12 px-0 text-center fs-7'>
                                            <span>
                                                You have not added any expertise yet. This is required to be offered relevant jobs.
                                            </span>
                                        </div>
                                    </div>

                                    <div className='align-items-center justify-content-center mx-0 pt-4 row pb-5'>
                                        <div className='align-items-center col-12 d-flex justify-content-center'>
                                            <div onClick={(e) => handleOpenExpertiseTrigger(e, 1)} className='cursor-pointer fs-6 fw-bold text-black text-center overlay-action-btn px-2 py-1 rounded-1'>
                                                <i className="bi bi-plus-circle pe-3"></i>
                                                <span >
                                                    Add expertise
                                                </span>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        }
                    </div>
                </div>

                {firstAPIRes && !adminTrigger && <ResponceForAPI show={firstAPIRes} />}

            </Card>





            {/* <!-- Modal For the expertise edit/delete/add --> */}
            <>

                <Modal className="fade" show={expertiseTrigger}
                    // onHide={handleClose} 
                    centered
                >

                    <Modal.Body>

                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <form onSubmit={(e) => saveProfessionalExperties(e)} >
                                    <div className='mx-0 row text-black mb-4'>
                                        <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                            <span>
                                                {expertiseModalTitle === 0 ? <>{txtExpertiseDetails}</> :
                                                    expertiseModalTitle === 1 ? <>{txtAddExpertise}</> :
                                                        expertiseModalTitle === 2 ? <>{txtEditExpertise}</> :
                                                            expertiseModalTitle === 3 ? <>{txtExpertiseDeleteConfirmation} </> : <></>
                                                }
                                            </span>
                                        </div>
                                        <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                            <span onClick={() => handleCloseExpertiseTrigger()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>


                                    {/* Add Or Edit */}
                                    {(expertiseModalTitle === 1 || expertiseModalTitle === 2) &&
                                        (<>
                                            <div className='row mx-0'>
                                                <div className={`col-12 px-0 ${isEditedExpertiseId && "mb-3"}`}>
                                                    {!isEditedExpertiseId &&
                                                        <SelectInputCategories
                                                            labelName={txtExpertiseName}
                                                            onChange={(e) => saveExpertiseNameFn(e)}
                                                            defaultValue={saveExpertiseName}
                                                            options={catArr}
                                                            errorOccured={isExpertiesNameError}
                                                            errorMessage={"Please select expertise"}
                                                            isRequired={true}
                                                        />
                                                    }

                                                    {isEditedExpertiseId && <span className='font-w600 fs-4 text-black'>{saveExpertiseName}</span>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 justify-content-between'>
                                                <div className='col-md-6 px-0 pe-md-2'>
                                                    <SelectInputCompetency
                                                        labelName={txtExpertiseCompetency}
                                                        onChange={(e) => saveExpertiseCompetencyFn(e)}
                                                        defaultValue={saveExpertiseCompetency}
                                                        options={expertiseCompetencyArr}
                                                        errorOccured={isExpertiesCompetencyError}
                                                        errorMessage={"Please select competency"}
                                                        isRequired={true}
                                                    />
                                                </div>

                                                <div className='col-md-6 px-0  ps-md-2'>
                                                    {/* <SelectInputCertification
                                                        labelName={txtCertification}
                                                        defaultValue={saveExpertiseCertificate}
                                                        onChange={(e) => saveExpertiseCertificateFn(e)}
                                                        options={certificationArr}
                                                        errorOccured={isExpertiesCertificationError}
                                                        errorMessage={"Please select certification"}
                                                    /> */}

                                                    <InputField
                                                        labelName={"Year of experience"}
                                                        placeholderName={"Year of experience"}
                                                        onChange={saveExpertiseExpFn}
                                                        onBlur={handleSaveExpertiseExpBlurCheck}
                                                        errorOccured={isExpertiesExpError}
                                                        errorMeesage={validTotalWorkExp}
                                                        value={`${saveExpertiseExp}`}
                                                        maxLength={2}
                                                        isRequired={true}
                                                    />

                                                </div>
                                            </div>

                                            {/* <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <InputField
                                                        labelName={"Year of experience"}
                                                        placeholderName={"Year of experience"}
                                                        onChange={saveExpertiseExpFn}
                                                        onBlur={handleSaveExpertiseExpBlurCheck}
                                                        errorOccured={isExpertiesExpError}
                                                        errorMeesage={validTotalWorkExp}
                                                        value={`${saveExpertiseExp}`}
                                                        maxLength={2}
                                                    />
                                                </div>
                                            </div> */}

                                            <div className='mt-2 mx-0 row'>
                                                <div className='col-12 px-0'>
                                                    <TextArea
                                                        labelName={`Bio`}
                                                        placeholder={`Bio`}
                                                        value={bioText}
                                                        onChange={handleBioText}
                                                        rows='3'
                                                        onBlur={() => { }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mx-0 mb-3">
                                                <div className="col-12 px-0 d-flex align-items-center" >
                                                    <span className="me-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={saveExpertiseCertificate}
                                                            className="form-check-input"
                                                            id="customCheckBox4"
                                                            onChange={(e) => {
                                                                setSaveExpertiseCertificate(e.target.checked)
                                                            }}
                                                            onClick={() => { setSaveExpertiseCertificate(!saveExpertiseCertificate) }}
                                                        />
                                                    </span>
                                                    <span
                                                        className="pt-1 cursor-pointer text-hovered font-w600 fs-6"
                                                        onClick={() => {
                                                            setSaveExpertiseCertificate(!saveExpertiseCertificate)
                                                        }}
                                                    >
                                                        {`I’m a certified expert`}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-2'>
                                                <div className='col-12 px-0'>
                                                    <PrimaryButton
                                                        onClick={(e) => saveProfessionalExperties(e)}
                                                        buttonName={btnSaveExpertise.toUpperCase()}
                                                        type={"submit"}
                                                        loadingMessage={btnSaveExpertiseLoading.toUpperCase()}
                                                        isLoading={saveExpertiseLoading}
                                                        style={{
                                                            width: '100%',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            border: '1px solid rgba(255, 154, 32, 1)',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </>)
                                    }

                                    {/* Delete */}
                                    {((expertiseModalTitle === 0) || (expertiseModalTitle === 3)) &&
                                        <>
                                            <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{txtExpertiseName}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{expertiseNameDia}</span>
                                                </div>
                                            </div>

                                            <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{txtExpertiseCompetency}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{expertiseCompetencyDia}</span>
                                                </div>
                                            </div>



                                            <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{txtWorkExperience}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{`${expertiseExpDia} years experience`}</span>
                                                </div>
                                            </div>

                                            <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{txtCertified}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{`${expertiseCertifiedDia}`}</span>  {expertiseCertifiedDia == "Yes" && <span><i className="bi bi-patch-check-fill ps-2 text-success"></i></span>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 text-black mt-2'>
                                                <div className='col-12 px-0 font-w600'>
                                                    <PrimaryButton
                                                        onClick={(e) => delelteExpertiseWithProduct(expertiseID)}
                                                        buttonName={'YES, I CONFIRM'}
                                                        type={"submit"}
                                                        loadingMessage={'DELETING...'}
                                                        isLoading={saveExpertiseLoading}
                                                        style={{
                                                            width: '100%',
                                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                            border: '2px solid rgba(240, 72, 72, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                            borderRadius: '4px',
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </>
                                    }

                                </form>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>

            {/* Modal for the Use Chilll As*/}
            <Modal className='fade' centered show={useChilllModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Use Chilll to"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseUseChilllModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Do you `}
                                        </span>
                                    </div>
                                </div> */}

                                <div className='row mb-4'>
                                    <div className='col-12 px-0'>
                                        {serviceRequestOptions?.map((ele, index) => {
                                            return (
                                                <div key={index} className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { handleServiceRequestoption(ele) }}>
                                                    <div className='col-12 font-w500 fs-4 px-0 text-center '>
                                                        <div className={`${index !== (serviceRequestOptions.length - 1) && "border-bottom"} mx-0 p-2 row `}>
                                                            <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                                                <input
                                                                    className="form-check-input d-flex"
                                                                    type="radio"
                                                                    name="avatar"
                                                                    value={ele.option_id_ids}
                                                                    onChange={(e) => setServiceReqOptionId(ele.option_id_ids)}
                                                                    checked={ele.option_id_ids === serviceReqOptionId}
                                                                />
                                                            </div>

                                                            <div className={`align-items-cente col-10 d-flex px-0 ${ele.option_id_ids === serviceReqOptionId ? "font-w600" : "font-w500"}`}>
                                                                <span>
                                                                    {ele.option_value_chr}
                                                                </span>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })}

                                        {serviceReqOptionErr &&
                                            <span className='text-danger'>{`Please select option`}</span>
                                        }
                                    </div>
                                </div>



                                <div className='row mx-0 mt-2'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                // uploadProfessionalDocuments()
                                                handleSubmitServiceReqOption()
                                            }}
                                            buttonName={"SUBMIT"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={serviceReqOptionLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>

                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && !adminTrigger && <ResponceForAPI show={apiResponce} />} */}

        </>
    )
}

export default WorkInfoCopy;